import { Button, Panel } from 'components'
import { startCase } from 'lodash-es'
import { useTheme } from 'utils'
import { EventStatus } from '../../utils'

export type EventStatusFilterValue = 'all' | EventStatus

interface Props {
  counts: { live: number; upcoming: number; past: number }
  onChange: (value: EventStatusFilterValue) => void
  value: EventStatusFilterValue
}

const OPTIONS: EventStatusFilterValue[] = ['all', 'live', 'upcoming', 'past']

export default function EventStatusFilter({ counts, onChange, value }: Props) {
  const { theme } = useTheme()
  const totalCount = counts.live + counts.upcoming + counts.past

  const getCount = (option: EventStatusFilterValue) => {
    if (option === 'all') return totalCount
    return counts[option]
  }

  return (
    <Panel align="center" direction="row" gap={0} h={9} p={1}>
      {OPTIONS.map(option => {
        const count = getCount(option)
        const isSelected = value === option

        return (
          <Button
            key={option}
            variant="ghost"
            onClick={() => onChange(option)}
            h="100%"
            size="sm"
            borderRadius="sm"
            opacity={isSelected ? 1 : 0.5}
            bg={isSelected ? (theme === 'light' ? 'white' : 'rgba(255, 255, 255, 0.1)') : undefined}
            boxShadow={isSelected && theme === 'light' ? 'sm' : undefined}
          >
            {startCase(option)} ({count})
          </Button>
        )
      })}
    </Panel>
  )
}
